import React, { createContext, useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';

interface DirectInputState {
  // Search and Filter State
  keywordsList: string[];
  setKeywordsList: React.Dispatch<React.SetStateAction<string[]>>;
  filter_id: string;
  setfilter_id: React.Dispatch<React.SetStateAction<string>>;
  lockedProducerLiterals: string[];
  setLockedProducerLiterals: React.Dispatch<React.SetStateAction<string[]>>;
  search_partial: boolean;
  setSearch_partial: React.Dispatch<React.SetStateAction<boolean>>;
  search_partialProducer: boolean;
  setSearch_partialProducer: React.Dispatch<React.SetStateAction<boolean>>;

  // Table Data State
  fetchedWines: any[];
  setFetchedWines: React.Dispatch<React.SetStateAction<any[]>>;
  fetchedProducers: any[];
  setFetchedProducers: React.Dispatch<React.SetStateAction<any[]>>;
  selectedWineRows: any[];
  setSelectedWineRows: React.Dispatch<React.SetStateAction<any[]>>;
  mergeModalWines: any[];
  setMergeModalWines: React.Dispatch<React.SetStateAction<any[]>>;

  // Pagination State
  winesPage: number;
  setWinesPage: React.Dispatch<React.SetStateAction<number>>;
  producersPage: number;
  setProducersPage: React.Dispatch<React.SetStateAction<number>>;
  hasMoreWines: boolean;
  setHasMoreWines: React.Dispatch<React.SetStateAction<boolean>>;
  hasMoreProducers: boolean;
  setHasMoreProducers: React.Dispatch<React.SetStateAction<boolean>>;
  totalRowsOfWines: number;
  setTotalRowsOfWines: React.Dispatch<React.SetStateAction<number>>;
  totalRowsOfProducers: number;
  setTotalRowsOfProducers: React.Dispatch<React.SetStateAction<number>>;

  // UI State
  showMergeModal: boolean;
  setShowMergeModal: React.Dispatch<React.SetStateAction<boolean>>;
  showProducerModal: boolean;
  setShowProducerModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedProducerId: string | null;
  setSelectedProducerId: React.Dispatch<React.SetStateAction<string | null>>;

}

export const DirectInputContext = createContext<DirectInputState | undefined>(undefined);

export const DirectInputProvider = () => {
  // Search and Filter State
  const [keywordsList, setKeywordsList] = useState<string[]>([]);
  const [filter_id, setfilter_id] = useState('');
  const [lockedProducerLiterals, setLockedProducerLiterals] = useState<string[]>([]);
  const [search_partial, setSearch_partial] = useState<boolean>(true);
  const [search_partialProducer, setSearch_partialProducer] = useState<boolean>(true);

  // Table Data State
  const [fetchedWines, setFetchedWines] = useState<any[]>([]);
  const [fetchedProducers, setFetchedProducers] = useState<any[]>([]);
  const [selectedWineRows, setSelectedWineRows] = useState<any[]>([]);
  const [mergeModalWines, setMergeModalWines] = useState<any[]>([]);

  // Pagination State
  const [winesPage, setWinesPage] = useState(1);
  const [producersPage, setProducersPage] = useState(1);
  const [hasMoreWines, setHasMoreWines] = useState(true);
  const [hasMoreProducers, setHasMoreProducers] = useState(true);
  const [totalRowsOfWines, setTotalRowsOfWines] = useState(0);
  const [totalRowsOfProducers, setTotalRowsOfProducers] = useState(0);

  // UI State
  const [showMergeModal, setShowMergeModal] = useState(false);
  const [showProducerModal, setShowProducerModal] = useState(false);
  const [selectedProducerId, setSelectedProducerId] = useState<string | null>(null);

  return (
    <DirectInputContext.Provider value={{
      // Search and Filter State
      keywordsList,
      setKeywordsList,
      filter_id,
      setfilter_id,
      lockedProducerLiterals,
      setLockedProducerLiterals,
      search_partial,
      setSearch_partial,
      search_partialProducer,
      setSearch_partialProducer,

      // Table Data State
      fetchedWines,
      setFetchedWines,
      fetchedProducers,
      setFetchedProducers,
      selectedWineRows,
      setSelectedWineRows,
      mergeModalWines,
      setMergeModalWines,

      // Pagination State
      winesPage,
      setWinesPage,
      producersPage,
      setProducersPage,
      hasMoreWines,
      setHasMoreWines,
      hasMoreProducers,
      setHasMoreProducers,
      totalRowsOfWines,
      setTotalRowsOfWines,
      totalRowsOfProducers,
      setTotalRowsOfProducers,

      // UI State
      showMergeModal,
      setShowMergeModal,
      showProducerModal,
      setShowProducerModal,
      selectedProducerId,
      setSelectedProducerId,

    }}>
      <Outlet />
    </DirectInputContext.Provider>
  );
};

export const useDirectInputContext = () => {
  const ctx = useContext(DirectInputContext);
  if (!ctx) throw new Error('useDirectInputContext must be used within a DirectInputProvider');
  return ctx;
};
